const BASE = import.meta.env.VITE_API_BASE_URL || ''

async function request(path, options = {}) {
  const url = `${BASE}${path}`
  const res = await fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  })

  if (!res.ok) {
    const body = await res.json().catch(() => null)
    const message = body?.error || body?.message || `Request failed: ${res.status}`
    const err = new Error(message)
    err.status = res.status
    throw err
  }

  return res.json()
}

export const api = {
  get: (path) => request(path, { method: 'GET' }),
  post: (path, body) =>
    request(path, { method: 'POST', body: JSON.stringify(body) }),
  put: (path, body) =>
    request(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: (path, body) =>
    request(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: (path) => request(path, { method: 'DELETE' }),
}

export const teamApi = {
  getCurrent: () => api.get('/api/team/current'),
  create: (data) => api.post('/api/team', data),
}

export const parentApi = {
  list: (teamId) => api.get(`/api/teams/${teamId}/parents`),
  create: (teamId, data) => api.post(`/api/teams/${teamId}/parents`, data),
  update: (teamId, id, data) => api.put(`/api/teams/${teamId}/parents/${id}`, data),
  delete: (teamId, id) => api.delete(`/api/teams/${teamId}/parents/${id}`),
}

export const draftNoteApi = {
  list: (teamId) => api.get(`/api/teams/${teamId}/draft-notes`),
  create: (teamId, data) => api.post(`/api/teams/${teamId}/draft-notes`, data),
  update: (teamId, id, data) => api.put(`/api/teams/${teamId}/draft-notes/${id}`, data),
  delete: (teamId, id) => api.delete(`/api/teams/${teamId}/draft-notes/${id}`),
}

export const dispatchApi = {
  list: (teamId) => api.get(`/api/teams/${teamId}/dispatches`),
}
